import {setPulledEffects} from 'actions/index.js';

export const dropPulledEffect = (effect, effectDragging, sequencerEngine) => {
    if (effect === effectDragging) {
        return;
    }
    let pulledEffects = sequencerEngine.state.effects.pulledEffects;
    let toIndex = sequencerEngine.state.effects.pulledEffects.indexOf(effect);
    let fromIndex = sequencerEngine.state.effects.pulledEffects.indexOf(effectDragging);

    let _pulledEffects;
    if (fromIndex > toIndex) {
        _pulledEffects = [
            ... pulledEffects.slice(0, toIndex),
            effectDragging,
            ... pulledEffects.slice(toIndex, fromIndex)];
        if (pulledEffects.length > fromIndex + 1) {
            _pulledEffects = [..._pulledEffects, ...pulledEffects.slice(fromIndex + 1)];
        }
    } else {
        _pulledEffects = [... pulledEffects.slice(0, fromIndex),
                          ... pulledEffects.slice(fromIndex + 1, toIndex),
                          effect,
                          effectDragging];
        if (pulledEffects.length > toIndex + 1) {
            _pulledEffects = [... _pulledEffects, ... pulledEffects.slice(toIndex + 1)];
        }
    }
    sequencerEngine.dispatch(
        setPulledEffects(_pulledEffects));
};
